import BusinessLogo from './BusinessLogo';

export {
  BusinessLogo
};



// WEBPACK FOOTER //
// ./src/components/Logo/index.js